import get from 'lodash/get'
import { fetchLatestMortgageRates as fetchRates } from '../api/mikasa/requests'
import {
  FETCH_LATEST_MORTGAGE_RATES_REQUEST,
  FETCH_LATEST_MORTGAGE_RATES_SUCCESS,
  FETCH_LATEST_MORTGAGE_RATES_FAILURE
} from '../actions/actionTypes'

export const fetchLatestMortgageRates = () => async (dispatch, getState) => {
  dispatch({
    type: FETCH_LATEST_MORTGAGE_RATES_REQUEST
  })

  try {
    const response = await fetchRates()
    const latestMortgageRatesData = get(response, 'data.data')

    dispatch({
      type: FETCH_LATEST_MORTGAGE_RATES_SUCCESS,
      data: latestMortgageRatesData
    })
  } catch (e) {
    dispatch({
      type: FETCH_LATEST_MORTGAGE_RATES_FAILURE,
      error: e
    })
  }
}
